import React from 'react';
import { Helmet } from 'react-helmet';

import { translate } from '@/i18n/src/locales';
import TitlePage from '@/components/TitlePage';
import Card from '@/components/Card';
// import { Container } from './styles';

function Franchisors() {
  return (
    <>
      <Helmet>
        <title>Administração Franqueadora - {translate('franchisors')}</title>
      </Helmet>
      <TitlePage title={translate('franchisors')} />
      <Card>teste</Card>
    </>
  );
}

export default Franchisors;
